import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ["Mujeres de 35 a 55 años que se sienten 'inflamadas' constantemente.", 'Profesionales con agendas saturadas que no tienen 2 horas para el gimnasio.', 'Madres que priorizan a todos los demás y han descuidado su propia energía.', 'Mujeres en perimenopausia que notan un cambio repentino en su zona abdominal.'];
  const isNotFor = ["Personas que buscan una 'pastilla mágica' sin cambiar sus rituales diarios.", 'Quienes disfrutan de entrenamientos de altísima intensidad y no quieren bajar el ritmo.', 'Atletas de élite con necesidades nutricionales específicas de competición.'];
  return <section className="py-24 bg-white" data-id="element-182">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-184">
          <FadeIn direction="right" data-id="element-185">
            <div className="bg-sage-light/20 rounded-3xl p-8 md:p-10 border border-sage-light" data-id="element-186">
              <h3 className="text-2xl font-bold mb-8 flex items-center" data-id="element-187">
                <span className="bg-sage text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-188">
                  ✓
                </span>
                Esto ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-189">
                {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-190">
                    <CheckCircle2Icon className="w-6 h-6 text-sage shrink-0 mr-3 mt-0.5" data-id="element-191" />
                    <span className="text-brown/80 leading-relaxed" data-id="element-192">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-193">
            <div className="bg-cream rounded-3xl p-8 md:p-10 border border-cream" data-id="element-194">
              <h3 className="text-2xl font-bold mb-8 flex items-center text-brown/60" data-id="element-195">
                <span className="bg-brown/20 text-brown w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-196">
                  ✕
                </span>
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-197">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-198">
                    <XCircleIcon className="w-6 h-6 text-brown/40 shrink-0 mr-3 mt-0.5" data-id="element-199" />
                    <span className="text-brown/60 leading-relaxed" data-id="element-200">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}